import React from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import { colors } from '@com/core/noon/styles/noonTheme';
import { TModuleGroup } from '@com/core/common/types/catalog';
import staticContentValidator from '@com/core/common/utils/staticContentValidator';

type TComponentAreaProps = {
    bgColor?: string;
};

const ComponentAreaContainer = styled.div<TComponentAreaProps>`
    overflow: hidden;
    background-position: top center;
    background-size: cover;
    position: relative;
    ${({ bgColor }): string => (bgColor ? `background: ${bgColor} !important;` : '')}

    /* -------------------------------------> 3. DEV PURPOSES ONLY */
    code {
        background-color: ${colors.bgSecondary};
        border-radius: 4px;
        display: block;
        color: #fff;
        padding: 15px 15px 20px;
        overflow-y: auto;
    }
`;

const ComponentAreaBgImage = styled.div<{ bgImage?: string }>`
    position: absolute;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    background-image: url(${({ bgImage }: { bgImage?: string }): string => bgImage || 'none'});
`;

const getQueryString = (key?: string): string => {
    if (typeof window === 'undefined') {
        return '';
    }
    if (key && key.length > 0) {
        return decodeURIComponent(
            window.location.search.replace(
                new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[.+*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'),
                '$1',
            ),
        );
    }
    return window.location.search;
};

const DEBUG = process.env.ENV === 'staging' && getQueryString('debug') === 'true';

type TProps = {
    componentArea: TModuleGroup;
    children: JSX.Element | JSX.Element[];
};

const ComponentArea = ({ children, componentArea }: TProps): JSX.Element => {
    staticContentValidator.validColor(componentArea.bgColor, componentArea);

    return (
        <ComponentAreaContainer bgColor={componentArea.bgColor}>
            {componentArea.bgImage && (
                <LazyLoad once offset={300}>
                    <ComponentAreaBgImage bgImage={componentArea.bgImage} />
                </LazyLoad>
            )}
            {children}
            {DEBUG && (
                <code>
                    <pre>{JSON.stringify(componentArea, null, 2)}</pre>
                </code>
            )}
        </ComponentAreaContainer>
    );
};

export default ComponentArea;
